import QuestionCircleIcon from '@atlaskit/icon/core/question-circle';
import ShieldDefaultIcon from '@atlaskit/icon/core/shield';
import { H6, LinkWithIcon } from '@atlassian/mpac-primitives';
import { usePrivacyAndSecurityAnalytics } from '../../hooks';
import { Container, Content, ContentColumn, ContentRight, ContentSection, Header, Heading, IconWrapper, Label } from './Certification.styles';
import { CloudFortifiedContent } from './CloudFortifiedContent';
import { CloudSecurityParticipantContent } from './CloudSecurityParticipantContent';
import { RunsOnAtlassianContent } from './RunsOnAtlassianContent';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const Certification = props => {
  const {
    fireTrustProgramsLinkEvent
  } = usePrivacyAndSecurityAnalytics();
  const {
    appName,
    partnerName,
    partnerUrl,
    isAppCloudFortified,
    isRunsOnAtlassian,
    isAppCloudSecurityParticipant
  } = props;
  const renderCloudContent = () => {
    if (isAppCloudFortified) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [isRunsOnAtlassian && /*#__PURE__*/_jsx(ContentColumn, {
          children: /*#__PURE__*/_jsx(RunsOnAtlassianContent, {})
        }), appName && partnerName && partnerUrl && /*#__PURE__*/_jsx(ContentColumn, {
          children: /*#__PURE__*/_jsx(CloudFortifiedContent, {
            appName: appName,
            partnerName: partnerName,
            partnerUrl: partnerUrl
          })
        })]
      });
    } else if (isRunsOnAtlassian) {
      return /*#__PURE__*/_jsx(ContentColumn, {
        children: /*#__PURE__*/_jsx(RunsOnAtlassianContent, {})
      });
    } else if (isAppCloudSecurityParticipant) {
      return /*#__PURE__*/_jsx(ContentColumn, {
        children: /*#__PURE__*/_jsx(CloudSecurityParticipantContent, {})
      });
    } else {
      return null;
    }
  };
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(Header, {
      children: [/*#__PURE__*/_jsx(ShieldDefaultIcon, {
        label: "shield-default-icon"
      }), /*#__PURE__*/_jsx(Heading, {
        children: "Atlassian trust programs"
      })]
    }), /*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx(_Fragment, {
        children: renderCloudContent()
      }), /*#__PURE__*/_jsxs(ContentRight, {
        children: [/*#__PURE__*/_jsx(IconWrapper, {
          children: /*#__PURE__*/_jsx(QuestionCircleIcon, {
            label: "question icon"
          })
        }), /*#__PURE__*/_jsxs(ContentSection, {
          children: [/*#__PURE__*/_jsx(H6, {
            children: "How do these programs address app trust?"
          }), /*#__PURE__*/_jsx(Label, {
            children: "Marketplace programs help Marketplace partners achieve the highest consistent standards for application security and privacy."
          }), /*#__PURE__*/_jsx(LinkWithIcon, {
            onClick: () => fireTrustProgramsLinkEvent('About trust program'),
            type: "external",
            size: "medium",
            href: "https://www.atlassian.com/trust/marketplace",
            "aria-label": "About the Marketplace Bug Bounty program open in a new window",
            children: "About trust programs"
          })]
        })]
      })]
    })]
  });
};